import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityManager } from '@proximus/entity-manager';
import { map } from 'rxjs/operators';
import { getIEntity, updateIEntity } from './entities.config';
import { UserRight } from './model/user-right.model';

@Injectable()
export class UserAccessService {

  fetchUserRights(): Observable<UserRight[]> {
    return EntityManager.getEntity<UserRight[]>(getIEntity).pipe(map((entity) => entity.value));
  }

  updateUserRights(userRights: UserRight[]): Observable<void> {
    const entity = EntityManager.createEntity(updateIEntity , {});
    entity.value = userRights;
    return EntityManager.updateEntity(entity).pipe(map(() => undefined));
  }
}
